module.exports = __webpack_public_path__ + "assets/img/face_search_describe.5b0be65c.png";